import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { load } from 'actions/admin';
import SimpleSpoof, { DefaultOptions } from 'components/simpleSpoof';
import { Help, SystemText, DebugInfo } from 'e4shared';

export const SpoofUsers = props => {
    const dispatch = useDispatch();
    const user = useSelector(state => state.user.user);

    React.useEffect(() => {
        // This page is only for PRISM partner/spoofing only
        if (!user.companySettings?.prism_UI || (!user?.partner_Id > 0 && !user?.spoofing)) {
            props.history.replace('/');
        }
    }, [user]);

    const text = {
        table: {
            options: {
                user: {
                    label: SystemText('Spoof/User/Table/Options/User/Label'),
                },
                spoof: {
                    label: SystemText('Spoof/User/Table/Options/Spoof/Label'),
                },
            },
            columns: {
                user: SystemText('Spoof/User/Table/Columns/User'),
                email: SystemText('Spoof/User/Table/Columns/Email'),
                administrator: SystemText('Spoof/User/Table/Columns/Administrator'),
                levels: {
                    admin: SystemText('Spoof/User/Table/Columns/Permission/Admin'),
                    config: SystemText('Spoof/User/Table/Columns/Permission/Config'),
                },
            },
        },
        filter: {
            help: SystemText('Spoof/User/Filter/Help'),
        },
    };

    const allProfiles = useSelector(state => state.admin.profiles) || [];

    const data = allProfiles?.map(p => ({
        ...p,
        zero: p.licence === 'ZERO',
    }));

    React.useEffect(() => {
        api.load(user.spoofing);
    }, [user.spoofing]);

    React.useEffect(() => {
        DebugInfo('component', 'SpoofUsers');
    }, []);

    const api = {
        load: spoofing => {
            dispatch(load('profile', false, spoofing));
        },
    };

    const spoofUser = userToSpoof => {
        props.history.push?.(`/spoofing?email=${encodeURIComponent(userToSpoof.email)}&spoofing=${user.spoofing}`);
    };

    const options = {
        ...DefaultOptions(),
        sortBy: 'list_Name',
        showActive: false, // must be false to remove activate/deactivate button
        label: text.table.options.user.label,
        mainColumnIndex: 1,
        showBulk: true,
        extraOptions: [
            {
                btnClass: 'btn-primary',
                label: text.table.options.spoof.label, // "Spoof" to add to name to get e.g. "Spoof Sara Brown" on hover
                icon: 'fa-external-link',
                disabled: d => d.full_Name.localeCompare(user.full_Name) === 0 || d.zero,
                onClick: d => spoofUser(d),
            },
        ],
    };

    let tableColumns = [
        {
            label: text.table.columns.user,
            dataProperty: 'list_Name',
            searchProperty: 'full_Name',
            sortByFunction: (data, asc) => {
                const regPrefix = asc ? '1' : '0';
                const dir = asc ? 1 : -1;

                return data
                    .map(d => {
                        const sortPrefix = regPrefix;

                        return { ...d, sortProperty: `${sortPrefix}-${d.list_Name}` };
                    })
                    .sort((a, b) => (a.sortProperty > b.sortProperty ? 1 * dir : -1 * dir));
            },
            className: 'no-wrap',
        },
        { label: text.table.columns.email, dataProperty: 'email', searchProperty: 'email' },
        {
            label: text.table.columns.administrator,
            dataProperty: 'administrator',
            format: (v, d) => {
                const hover =
                    d.licence === 'ZERO'
                        ? ''
                        : d.administrator
                          ? text.table.columns.levels.admin
                          : d.sys_Config
                            ? text.table.columns.levels.config
                            : '';

                return hover ? (
                    <Help id={`help-admin-${d.id}`} target={<i className="fa fa-user-shield" />}>
                        {hover}
                    </Help>
                ) : (
                    <></>
                );
            },
        },
    ];

    return (
        <>
            {user.spoofing && (
                <div id="spoof-bar">
                    <div className="info-box">You are currently spoofing as {user.full_Name}</div>
                </div>
            )}
            {!user.spoofing && (
                <div>
                    <SimpleSpoof
                        {...props}
                        data={data}
                        options={options}
                        columns={tableColumns}
                        filterHelp={text.filter.help}
                        filterColumn="active"
                    />
                </div>
            )}
        </>
    );
};

export default SpoofUsers;
